module.exports = __webpack_public_path__ + "static/img/Store-11.983d4b03.png";